
import { defineComponent } from 'vue'
import {
  faFileCircleCheck,
  faFileCircleExclamation,
  faAddressCard,
  faBuildingColumns,
  faCheckDouble,
  faFileContract,
  faCheckCircle,
  faExclamationCircle,
  faListCheck
} from '@fortawesome/free-solid-svg-icons'
import { Steps } from '@design-system/ui'

import { ShopClientDTO } from '@/interfaces/ShopClientDTO'
import utils from '@/utils'

import SessionService from '../SessionService'
import api from '@/services/api'
import EstabelecimentoDetails from '../components/EstabelecimentoDetails.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Swal from 'sweetalert2'

export default defineComponent({
  name: 'EstabelecimentoEdit',
  components: {
    EstabelecimentoDetails,
    Steps,
    FontAwesomeIcon
  },
  data () {
    return {
      loading: false,
      softwareHouseCnpj: '',
      estabelecimento: {
        data: '',
        validacoes: '',
        status: ''
      },
      estabelecimentoDataLoaded: false,
      validateBypass: false,
      cnpjEstabelecimentoComercial: '',
      razaoEstabelecimentoComercial: '',
      mediatorFee: 0,
      currentStepDetails: {
        index: 0,
        sistema: '',
        message: '',
        class: '',
        icon: faCheckCircle,
        reason: ''
      },
      isFinished: true,
      alreadyRegistered: false,
      registerSteps: [
        {
          label: 'Cadastro',
          labelClass: 'text-md',
          icon: faFileCircleExclamation
        },
        {
          label: 'Em andamento',
          labelClass: 'text-md',
          icon: faAddressCard
        },
        {
          label: 'Validações',
          labelClass: 'text-md',
          icon: faCheckDouble
        },
        {
          label: 'Contrato',
          labelClass: 'text-md',
          icon: faFileContract
        },
        {
          label: 'Conta bancária',
          labelClass: 'text-md',
          icon: faBuildingColumns
        },
        {
          label: 'Concluído',
          labelClass: 'text-md',
          icon: faFileCircleCheck
        }
      ]
    }
  },
  mounted () {
    const session = new SessionService()
    if (!session.rootAccess() && !session.access()) {
      this.$router.push('/painel')
    }

    if (session.rootAccess()) {
      this.softwareHouseCnpj = this.$route.params.softwareHouseCnpj.toString()
    } else {
      this.softwareHouseCnpj = session.cnpj()
    }

    this.getEstabelecimento(this.$route.params.cnpj.toString())
  },
  methods: {
    openModal () {
      if (this.currentStepDetails.message.includes('[ERRO]')) {
        Swal.fire({
          title: this.currentStepDetails.message,

          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: 'Fechar',
          showConfirmButton: true,
          confirmButtonText: 'Copiar',
          customClass: {
            title: 'text-left text-xl font-bold',
            container: 'text-left'
          },
          html:
          '<p style="text-align: left;"><b>Motivo:</b></p>' +
    '<div style="background-color: #d1d5db; margin-top: 8px; border-radius: 8px; padding: 10px; text-align: left;">' +
    this.currentStepDetails.reason +
    '</div>'
        })

        const copyButton = document.querySelector('.swal2-confirm')
        if (copyButton) {
          copyButton.addEventListener('click', () => {
            navigator.clipboard.writeText(this.currentStepDetails.reason)
          })
        }
      }
    },

    async getEstabelecimento (cnpj: string) {
      this.loading = true
      this.isFinished = false
      try {
        const foundInDatabase = await this.getEstabelecimentoInDatabase(cnpj)
        this.estabelecimento.status = foundInDatabase.status
        this.estabelecimento.data = foundInDatabase
        this.mediatorFee = foundInDatabase.mediatorFee
        this.validateBypass = true

        if (this.estabelecimento.status !== 'cadastro_solicitado') {
          this.alreadyRegistered = true
        }

        if (this.estabelecimento.status === 'cadastro_concluido') {
          this.isFinished = true
        }
      } catch {
        const shopResponse = await api.get<ShopClientDTO>(`/shop/${this.softwareHouseCnpj}/companies/${cnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })

        const shopResponseData = shopResponse.data

        const companyCnpj = shopResponseData.person.juridicPerson?.cnpj
        const companyMediatorFeeResponse = await api.get(`/estabelecimentos-comerciais/${this.softwareHouseCnpj}/mediatorfee/${companyCnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        const data = companyMediatorFeeResponse.data

        this.estabelecimento.data = utils.formatSHOPToCompanyData(shopResponseData)
        this.estabelecimento.status = 'cadastro_concluido'
        this.mediatorFee = data.mediatorFee
        this.isFinished = true
        this.validateBypass = false
      }

      await this.handleStatus(cnpj)

      this.estabelecimentoDataLoaded = true
      this.loading = false
    },

    async getEstabelecimentoInDatabase (cnpj: string) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let estabelecimentoComercialData: any = {}
      const preRegister = await api.get(`/pre-register/estabelecimento-comercial/${this.softwareHouseCnpj}/${cnpj}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      estabelecimentoComercialData.corporateName = preRegister.data.corporateName
      estabelecimentoComercialData.cnpj = preRegister.data.cnpj
      estabelecimentoComercialData.mediatorFee = preRegister.data.mediatorFee
      estabelecimentoComercialData.preRegister = preRegister.data
      estabelecimentoComercialData.status = 'cadastro_solicitado'
      try {
        const estabelecimentoComercial = await api.get(`/estabelecimentos-comerciais/${this.softwareHouseCnpj}/${cnpj}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })

        estabelecimentoComercial.data.representatives = estabelecimentoComercial.data.representatives.sort((representative1, representative2) => {
          if (representative1.isMain === representative2.isMain) {
            return 0
          }
          return representative1.isMain ? -1 : 1
        })

        estabelecimentoComercialData = {
          ...estabelecimentoComercialData,
          ...estabelecimentoComercial.data
        }

        return estabelecimentoComercialData
      } catch (error) {
      }
      return estabelecimentoComercialData
    },

    getIndex (status: string) {
      switch (status) {
        case 'cadastro_solicitado':
          return 0
        case 'cadastro_andamento':
          return 1
        case 'pendente_validacoes':
          return 2
        case 'assinatura_contrato':
          return 3
        case 'abertura_conta':
          return 4
        case 'cadastro_concluido':
          return 5
        default:
          return 0
      }
    },

    async handleStatus (cnpj: string) {
      const estabelecimentoComercialLogs = await api.get(`/logs/${cnpj}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      if (estabelecimentoComercialLogs.data.data && estabelecimentoComercialLogs.data.data.length >= 1) {
        const lastLog = estabelecimentoComercialLogs.data.data[estabelecimentoComercialLogs.data.data.length - 1]

        this.currentStepDetails.message = lastLog.resposta.message

        if (lastLog.resposta.statusCode === 200) {
          this.currentStepDetails.class = 'bg-green-600'
          this.currentStepDetails.icon = faCheckCircle
        } else if (lastLog.resposta.statusCode >= 201 &&
        lastLog.resposta.statusCode <= 299) {
          this.currentStepDetails.class = 'bg-blue-600'
          this.currentStepDetails.icon = faListCheck
        } else {
          this.currentStepDetails.class = 'bg-red-600'
          this.currentStepDetails.icon = faExclamationCircle
          this.currentStepDetails.reason = JSON.stringify(lastLog.resposta.reason, null, 2)
        }
      }
    }
  },
  beforeMount () {
    this.$store.commit('changeActiveMenu', 2)
  }
})
